import {
    PayloadAction,
    createAsyncThunk,
    createEntityAdapter,
    createSlice,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import * as permissionService from './permission.service';
import { Permission } from '../../service/model/role.model';

export interface PermissionState {
    isLoading: boolean;
}

const permissionsAdapter = createEntityAdapter<Permission>({
    sortComparer: (a, b) => a.module?.localeCompare(b.module || ''),
});

export const initialState = permissionsAdapter.getInitialState({
    isLoading: false,
} as PermissionState);

export const fetchPermissions = createAsyncThunk<Permission[]>(
    'permissions/all',
    async (_, { rejectWithValue }) => {
        return permissionService.getPermissions().catch((errors) => {
            return rejectWithValue(errors);
        });
    },
);

const permissionSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPermissions.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(
                fetchPermissions.fulfilled,
                (state, action: PayloadAction<Permission[]>) => {
                    permissionsAdapter.setAll(state, action.payload);
                    state.isLoading = false;
                },
            )
            .addCase(fetchPermissions.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const {
    selectAll: selectPermissions,
    selectById: selectPermissionById,
} = permissionsAdapter.getSelectors<RootState>((state) => state.permissions);

export const permissionActions = permissionSlice.actions;

export const selectIsLoading = (state: RootState) =>
    state.permissions?.isLoading;

export default permissionSlice.reducer;
